'use strict';
import { slideDown, slideUp } from 'slide-anim';

export function initAccordions(wrappers) {
  wrappers.forEach((wrapper) => {
    const button = wrapper.querySelector('.js-accordion-button');
    const target = wrapper.querySelector('.js-accordion-target');

    // トリガーを押した時のアクション
    let opened = false;
    const changeState = (state) => {
      opened = state;
    };
    const onClick = () => {
      if (opened) {
        wrapper.classList.remove('is-active');
        slideUp(target).then(changeState(false));
        return;
      }
      wrapper.classList.add('is-active');
      slideDown(target, { display: 'grid' }).then(changeState(true));
    };

    button.addEventListener('click', onClick);
  });
}
